import { ShowNasrocheniDelaComponent } from '../show-nasrocheni-dela.component';
import { Component, OnInit, forwardRef, Inject } from '@angular/core';

@Component({
  selector: 'app-row-content-dela',
  templateUrl: './row-content-dela.component.html',
  styleUrls: ['./row-content-dela.component.scss']
})

export class RowContentDelaComponent implements OnInit {
		selectedCase: any;
	constructor( @Inject(forwardRef(() => ShowNasrocheniDelaComponent)) private _parent: ShowNasrocheniDelaComponent) {
		this.selectedCase = _parent.selectedCase;
	}
  ngOnInit() {
  }

}
